module.exports = __webpack_public_path__ + "static/media/Engxg8.5173d20c.png";